import { generalSetting0, posSettings0 } from "@/data/PosSettingsSignal.ts";
import _ from "lodash";
import { computed, signal } from "@/react/core/reactive.ts";
import uuid from "time-uuid";
import { userFLow } from "@/shared/logger.ts";
import { loginUser } from "@/data/UserSignal.ts";
import { toast } from "react-toastify";
import type React from "react";
import { product0 } from "@/react/EditMenuView/EditMenuView.signal.ts";
import { modifiers0 } from "@/data/ModifierHub.ts";
import { selectedItem } from './EditMenuView.signal';
import { LL0 } from "@/react/core/I18nService.tsx";


export const multipleLanguagesEnableSwitch = () => ({
  checked: !!generalSetting0()?.multipleLanguagesEnable || false,
  onChange: (e: any) => {
    _.assign(generalSetting0(), { multipleLanguagesEnable: e.target.checked })
  }
})

export const multipleLanguages0 = computed(() => {
  if (!posSettings0() || posSettings0()?.length === 0) return
  if (!generalSetting0()) return [];
  if (!generalSetting0().multipleLanguages) {
    const initialLanguage = [{ _id: uuid(), name: 'default' }];
    generalSetting0().multipleLanguages = initialLanguage
    return generalSetting0().multipleLanguages || initialLanguage;
  }
  return generalSetting0().multipleLanguages;
});



export const [languageSelected, setLanguageSelected] = signal<string>(multipleLanguages0()?.[0]?._id || '');
export const [isMultiLanguageOpen, setIsMultiLanguageOpen] = signal<boolean>(false)

function setModifiersMultipleLanguages() {
  const language = languageSelected()
  const multipleEnable = generalSetting0().multipleLanguagesEnable
  const dineInModifiers = modifiers0().filter(m => !m.menus);
  if (dineInModifiers.length === 0) return;
  for (const dineInModifier of dineInModifiers) {
    const modifierItems = dineInModifier.items;
    for (const modifierItem of modifierItems!) {
      if (multipleEnable && language !== defaultLanguage()) {
        const index = modifierItem.languageNames?.findIndex(m => m.language === language);
        if (!modifierItem.languageNames || index === -1) {
          _.assign(modifierItem, {
            languageNames: [...modifierItem.languageNames ?? [], {
              language: language,
              name: modifierItem.name ?? ''
            }]
          });
        }
      }
    }
  }
}

export const defaultLanguage = computed(() => {
  if (!multipleLanguages0() || !multipleLanguages0()?.length) {
    return ''
  } else {
    return multipleLanguages0()?.[0]?._id
  }
})
export function updateLanguageSelection(e: (Event & {
  target: { value: unknown; name: string }
}) | React.ChangeEvent<HTMLInputElement>) {
  const selectLanguage = e.target.value as any;
  setLanguageSelected(selectLanguage as string);
  const _product = product0();
  const index = _product?.languageNames?.findIndex(m => m.language === selectLanguage);
  if (selectLanguage !== defaultLanguage() && (!_product?.languageNames || index === -1)) {
    _.assign(_product, { languageNames: [..._product?.languageNames ?? [], { language: selectLanguage, name: _product?.name }] });
  }
  setModifiersMultipleLanguages()
}

export const openMultiLanguage = (() => {
  userFLow(`open language multi language`, {
    username: loginUser()?.name
  });
  setIsMultiLanguageOpen(true);
});
export const closeMultiLanguage = (() => {
  userFLow(`close language multi language`, {
    username: loginUser()?.name
  });
  setIsMultiLanguageOpen(false);
});

export function addNewLanguage(language: string) {
  const _generalSetting = generalSetting0()
  const isLanguageExist = _generalSetting.multipleLanguages?.find(m => m.name === language)
  if (language.trim() === '') return;
  if (!isLanguageExist) {
    const newLanguages = [...(multipleLanguages0() || []), { _id: uuid(), name: language }]
    _.assign(generalSetting0(), { multipleLanguages: newLanguages })
  } else {
    toast('this menu is duplicated!!!')
  }
  closeMultiLanguage();
}

export function computedLanguage() {
  const  product = product0();
  const language = languageSelected()
  const multipleEnable = generalSetting0().multipleLanguagesEnable

  if (!product) return '';

  const shouldUseProductLanguage = !multipleEnable || language === defaultLanguage() || !language || !product.languageNames;
  if (shouldUseProductLanguage) return product.name || '';

  const languageName = product.languageNames?.find(m => m.language === language);
  return languageName?.name || product.name || '';
}

export function computedModifierItemName() {
  const language = languageSelected()
  const multipleEnable = generalSetting0().multipleLanguagesEnable

  if (!multipleEnable || language === defaultLanguage() || !language || !selectedItem()?.languageNames) {
    return selectedItem()?.name;
  } else {
    const languageName = selectedItem().languageNames!.find(m => m.language === language);
    if (!languageName) {
      return selectedItem()?.name
    } else {
      return languageName?.name;
    }
  }
}

export function handleModifierItemNameChange(e: string) {
  const language = languageSelected()
  const multipleEnable = generalSetting0().multipleLanguagesEnable

  const isOtherMenu = multipleEnable && language !== defaultLanguage();
  if (!isOtherMenu) {
    _.assign(selectedItem(), { name: e });
  } else {
    const _selectedItem = selectedItem();
    let index = _selectedItem?.languageNames?.findIndex(m => m.language === language);
    _.assign(_selectedItem?.languageNames?.[index!], { language: language, name: e });
  }
}